<template>
	<v-container class="px-2 py-0">
		<h2 v-if="titulo" class="mt-2">{{ titulo }}</h2>
		<v-row class="mt-1">
			<v-col class="mx-auto">
				<div>
					<span>La cantidad económica a devolver por parte de Umivale Activa es de </span>
					<span v-if="!isLoading" class="importe">{{
						formattedAmount }} €</span><br>
				</div>
				<v-alert class="my-5" type="info" color="#124D91" text>
					<span class="font-weight-bold">Únicamente aplicaremos retención de IRPF a las cantidades
						abonadas superiores a 100 €.</span><span> Tras verificar la documentación, realizaremos el abono en
						cuanto sea posible.</span>
				</v-alert>
				<div>
					<span v-if="isValidIbanOriginal">El número de cuenta registrado para realizar el ingreso es:</span>
					<span v-if="datosAbonoSolicitud.ibanOriginal && isValidIbanOriginal" class="num-iban-original">{{
						maskIbanOriginal }}</span>
				</div>
			</v-col>
		</v-row>

		<v-row class="mt-n1">
			<v-col class="mx-auto">
				<v-alert color="red" type="error" text>
					{{ textAlert }}
				</v-alert>
			</v-col>
		</v-row>

		<v-row v-if="isValidIbanOriginal" class="mt-n1">
			<v-col cols="12">
				<span>¿Es este número de cuenta correcto?</span>
			</v-col>
			<v-col cols="1" class="mt-n2 pt-0 pl-3 ">
				<v-radio-group v-model="datosAbonoSolicitud.radio" class="pt-0 pl-5" column
					:rules="[validationRules.requiredBoolean]">
					<v-radio label="Sí" :value="true" />
					<v-radio label="No" :value="false" />
				</v-radio-group>
			</v-col>
		</v-row>

		<DatosBancariosMain ref="refDatosBancarios"
			v-if="!isLoading && (!datosAbonoSolicitud.radio || !isValidIbanOriginal)" :ibanPropuesto="!datosAbonoSolicitud.radio && datosAbonoSolicitud.ibanConFormato ? datosAbonoSolicitud.ibanConFormato
				: null" />

		<v-row :style="{ 'padding-top': datosAbonoSolicitud.radio ? '0px' : '10px' }">
			<v-col cols="12">
				<span>
					Aporte un documento generado por la entidad bancaria que muestre claramente </span><span
					class="font-weight-bold"> que el beneficiario de la prestación es el titular de la cuenta.
				</span>

			</v-col>
			<v-col cols="12" no-gutter>
				<FileUploader v-if="!isLoading && documento && documento.idSolicitud" :idSolicitud="documento.idSolicitud"
					:idSolDocumento="documento.idSolDocumento ? documento.idSolDocumento : null"
					:idTipoDocumento="documento.idTipoDocumento" :nombreArchivo="documento.nombreArchivo"
					:idNotificacion="idFirmaDocumento ? idFirmaDocumento : null" :titulo=placeHolderFileUploader
					obligatorio="S" @uploaded="documentoChanged($event)" @deleted="deleteDocument($event)" />
			</v-col>
		</v-row>

		<v-skeleton-loader v-if="isLoading" type="card" class="mb-4 mx-auto" />

		<v-row v-if="!isLoading" class="my-6">
			<v-col>
				<v-btn class="btn-next" style="float:right;" @click="continueNext()" :disabled="disableContinuar"
					color="primary">Continuar
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import api from '@Base/services/auditoriaService';
import apiSolicitud from '@Base/services/solicitudService'
import DatosBancariosMain from './common/DatosBancariosMain.vue'
import FileUploader from './common/FileUploader.vue'
import MixinUtils from '@Base/utils/mixinUtils'
import StepBase from './common/StepBase';

export default {
	name: 'ComprobarIban',
	mixins: [MixinUtils, StepBase],
	components: {
		DatosBancariosMain,
		FileUploader
	},
	data() {
		return {
			idNotificacionOrigen: null,
			datosAbonoSolicitud: {},
			documento: null,
			idFirmaDocumento: null,
			isLoading: true,
			placeHolderFileUploader: 'Documento que acredite la tituralidad de la cuenta bancaria',
			textAlert: 'El beneficiario de la prestación debe ser el titular de la cuenta.',
			textDocumentoTitularCuenta: 'Es necesario que suba un documento que acredite la titularidad de la cuenta.',
			textInvalidIban: 'La cuenta IBAN proporcionada no es válida.',
			tituloConfirme: 'Confirme que el IBAN registrado es correcto',
			tituloNecesita: 'Se necesita un IBAN para poder realizarle el ingreso'
		}
	},
	computed: {
		formattedAmount() {
			// Verifica si el número es una cadena			
			if (typeof this.datosAbonoSolicitud.importeAbonar === 'string') {
				// Reemplaza puntos por comas en la cadena
				return this.datosAbonoSolicitud.importeAbonar.replace(/\./g, ',');
			} else {
				// Si el número es de otro tipo, lo converte a cadena y luego reemplaza los puntos por comas
				return this.datosAbonoSolicitud.importeAbonar.toString().replace(/\./g, ',');
			}
		},
		isValidIbanOriginal() {
			return (this.datosAbonoSolicitud.ibanOriginal && this.datosAbonoSolicitud.validoIbanOriginal && this.datosAbonoSolicitud.validoIbanOriginal == true) ? true : false
		},
		titulo() {
			return this.isValidIbanOriginal ? this.tituloConfirme : this.tituloNecesita
		},
		// disabled si no se ha subido documento que acredita la titularidad de la cuenta
		disableContinuar() {
			return (this.documento && !this.documento.nombreArchivo)
		},
		// implementa la máscara del IBAN
		maskIbanOriginal() {
			if (this.datosAbonoSolicitud.ibanOriginal) {
				const cleanedIBAN = this.datosAbonoSolicitud.ibanOriginal.replace(/[^a-zA-Z0-9]/g, '')
				return cleanedIBAN.replace(/(\w{2})(\w{4})(\w{4})(\w{5})(\w{5})/, '$1 $2 **** ** *****$5');
			}
			return null;
		},
	},
	methods: {
		// comprueba si existen hay notificaciones pendientes
		compruebaNotificacionPendiente() {
			this.isLoading = true;
			apiSolicitud.getNotificacionPendiente(
				// Enviamos el parámetro 'idNotificacion', aunque siempre será nulo, ya que aún no se ha almacenado. Es imprescindible hacerlo así para garantizar el correcto funcionamiento del servicio
				this.idFirmaDocumento,
				res => {
					this.isLoading = false;
					this.idFirmaDocumento = res.idFirmaDocumento
					this.idNotificacionOrigen = res.notificacionOrigen
					this.$store.commit('solicitud/SET_ID_NOTIFICACION', this.idNotificacionOrigen);
					this.$store.commit('solicitud/setIdNotificacionFavorableAbono', this.idFirmaDocumento);
					this.getDocumentoAbonoIban()
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al comprobar las notificaciones pendientes', color: 'red' });
					console.log(error);
				}
			);
		},
		// obtiene el documento que acredita la titularidad de la cuenta
		getDocumentoAbonoIban() {
			this.isLoading = true;
			api.getDocumentoAbonoIban(this.idFirmaDocumento,
				res => {
					this.documento = { ...res }
					this.isLoading = false;
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al obtener el documento de alegación', color: 'red' });
					console.log(error);
				}
			);
		},
		getAbonoSolicitud() {
			this.isLoading = true;
			api.getAbonoSolicitud(
				res => {
					this.datosAbonoSolicitud = { ...res }
					this.datosAbonoSolicitud.radio = this.datosAbonoSolicitud.validoIbanOriginal ? true : false
					this.isLoading = false;
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al obtener el número de cuenta asociado', color: 'red' });
					console.log(error);
				}
			);
		},
		// setea el número de cuenta IBAN
		setNumeroCuentaIban(ibanToSend) {
			const idSolicitud = this.$store.state.solicitud.audFirma.idSolicitante
			const datosIbanSolicitud = {
				idSolicitud: idSolicitud,
				iban: ibanToSend,
				origen: this.datosAbonoSolicitud.radio ? true : false,
				radio: this.datosAbonoSolicitud.radio
			}
			this.isLoading = true;
			api.setNumeroCuentaIban(datosIbanSolicitud,
				res => {
					if (res) {
						this.$router.push({ name: 'declaraciones', params: { id: this.$store.state.solicitud.tokenAcceso, notificacion: this.$store.state.solicitud.idNotificacion } });
					}
					this.isLoading = false;
				},
				error => {
					this.$emit('alert-event', { text: 'Error al guardar campo numero de cuenta', color: 'red' });
					this.isLoading = false;
					console.log(error);
				}
			);
		},
		deleteDocument(documento) {
			this.documento.nombreArchivo = null;
			this.observaciones = '';
		},
		documentoChanged(documento) {
			this.documento.idSolDocumento = documento.idSolDocumento;
			this.documento.nombreArchivo = documento.nombreArchivo;
		},
		continueNext() {
			// Si no se ha subido el documento que acredita la titularidad de la cuenta no continuamos
			if (!this.documento.nombreArchivo) {
				this.$emit('alert-event', { text: this.textDocumentoTitularCuenta, color: 'red' });
				return
			}
			// Validamos en el front que el IBAN a enviar es válido
			const ibanToValidate = this.datosAbonoSolicitud.radio ? this.datosAbonoSolicitud.ibanOriginal : this.$refs.refDatosBancarios.ibanConcatenado;
			const isValidIBan = this.validateIBAN(ibanToValidate);

			if (isValidIBan) {
				const ibanToSend = this.datosAbonoSolicitud.radio && this.isValidIbanOriginal ? this.datosAbonoSolicitud.ibanOriginal : this.$refs.refDatosBancarios.ibanConcatenado;
				this.setNumeroCuentaIban(ibanToSend);
			} else {
				this.$emit('alert-event', { text: this.textInvalidIban, color: 'red' });
			}
		}
	},
	watch: {
		$route(to) {
			this.$store.commit('solicitud/setTituloModulo', this.$store.state.solicitud.solicitante.tituloPrestacion);
			this.compruebaNotificacionPendiente()
			this.getAbonoSolicitud()
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.$store.commit('solicitud/setTituloModulo', vm.$store.state.solicitud.solicitante.tituloPrestacion);
			vm.compruebaNotificacionPendiente()
			vm.getAbonoSolicitud()
		})
	},
	beforeMount() {
		window.onbeforeunload = () => {
			return "¿Estás seguro de abandonar la página?. Los cambios no guardados se perderán.";
		};
	},
	beforeDestroy() {
		window.onbeforeunload = null; // Elimina el evento antes de destruir el componente
	}
}
</script>

<style>
.num-iban-original {
	font-family: Inter;
	font-size: 24px;
	font-weight: 700;
	line-height: 45px;
	letter-spacing: 0px;
	text-align: left;
	display: block;
}

.importe {
	font-weight: 700;
	font-size: 17px;
}
</style>